import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// APIクライアントのインスタンスを作成
const apiClient = axios.create({
  baseURL: API_URL + '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// 記事関連のAPI(ここはAPIのパス。フロントのパスではない。)
export const postsApi = {
  // 全ての記事を取得
  getAllPosts: () => {
    return apiClient.get('/posts');
  },
  
  getPostsByMonth: (ym) => {
    return apiClient.get(`/archive/${ym}`);
  },

  getPostsByCategory: (cat) => {
    return apiClient.get(`/category/${cat}`);
  },

  // 特定のIDの記事を取得
  getPost: (id) => {
    return apiClient.get(`/posts/${id}`);
  },
  
  // 新しい記事を作成
  createPost: (postData) => {
    return apiClient.post('/posts', postData);
  },
  
  // 記事を更新
  updatePost: (id, postData) => {
    return apiClient.put(`/posts/${id}`, postData);
  },
  
  // 記事を削除
  deletePost: (id) => {
    return apiClient.delete(`/posts/${id}`);
  },
};

// // コメント関連のAPI
// export const commentsApi = {
//   // 記事にコメントを追加
//   addComment: (postId, commentData) => {
//     return apiClient.post(`/posts/${postId}/comments`, commentData);
//   },
// };

// ユーザー関連のAPI
export const usersApi = {
  // 全てのユーザーを取得
  getAllUsers: () => {
    return apiClient.get('/users');
  },
  
  // 特定のIDのユーザーを取得
  getUser: (id) => {
    return apiClient.get(`/users/${id}`);
  },
  
  // 新しいユーザーを作成（登録）
  createUser: (userData) => {
    return apiClient.post('/users', userData);
  },
};

export default {
  posts: postsApi,
  // comments: commentsApi,
  users: usersApi,
};